/**
 * @file form组件
 * @author (zhaojun10)
 */
import Form from './Form.js';
import FormItem from './FormItem.js';
export { Form, FormItem };
export default Form;